/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

import type { IsoDate } from './IsoDate';
import type { IsoTime } from './IsoTime';
import type { MoneyAmount } from './MoneyAmount';
import type { Months } from './Months';
import type { StandingOrderDeprecatedExecutionInterval } from './StandingOrderDeprecatedExecutionInterval';
import type { StandingOrderExecutionBreak } from './StandingOrderExecutionBreak';
import type { StandingOrderExecutionInterval } from './StandingOrderExecutionInterval';
import type { StandingOrderExecutionMode } from './StandingOrderExecutionMode';

export type StandingOrderExecution = ((StandingOrderExecutionBreak | {
    /**
     * List of months when order will be executed. Applicable only with IRREGULAR execution interval.
     */
    months?: Array<Months>;
}) & {
    /**
     * Datetime when standing/sweep payment order was created, ISO dateTime format YYYY-MM-DDThh:mm:ssZ.
     */
    startDate?: string;
    interval: (StandingOrderExecutionInterval | StandingOrderDeprecatedExecutionInterval);
    mode: StandingOrderExecutionMode;
    /**
     * The attribute defines whether standing/sweep order is executed before or after the due date in case execution date is on non-banking day.
     *
     */
    nextDatePreference?: StandingOrderExecution.nextDatePreference;
    /**
     * Date when the standing/sweep order will be processed the next time. ISO 8601 date format YYYY-MM-DD.
     */
    nextDate?: IsoDate;
    /**
     * Time when the standing/sweep order will be processed. ISO 8601 time format hh:mm:ss.
     *
     */
    time?: IsoTime;
    /**
     * Executed number of iterations - processing of the standing order from beginning till current date.
     */
    executedIterations?: number;
    /**
     * Executed amount - sum of all transferred amounts from beginning till current date.
     */
    executedAmount?: MoneyAmount;
    /**
     * Possible value 1 - 14.
     */
    repetitionDays?: number;
    /**
     * Additional description of execution interval.
     */
    intervalDescription?: string;
});

export namespace StandingOrderExecution {

    /**
     * The attribute defines whether standing/sweep order is executed before or after the due date in case execution date is on non-banking day.
     *
     */
    export enum nextDatePreference {
        BEFORE_DUE_DATE = 'BEFORE_DUE_DATE',
        AFTER_DUE_DATE = 'AFTER_DUE_DATE',
    }


}

